import * as tslib_1 from "tslib";
import { FieldType } from '@ngx-formly/core';
var FormlyFieldRichTextComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FormlyFieldRichTextComponent, _super);
    function FormlyFieldRichTextComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyFieldRichTextComponent;
}(FieldType));
export { FormlyFieldRichTextComponent };
